/**
 * Determines whether a navigation description/link item would render anything
 * visible. Used to skip empty groups/sections that have no renderable content.
 *
 * @param {object} description - The description or link item to evaluate.
 * @param {object} [options]
 * @param {boolean} [options.isDescription=false] - When true, the renderable link
 *   is read from `description.link`; otherwise the item itself is the link.
 * @param {string} [options.moreParkHoursId] - The id used for the "more park hours" item.
 * @returns {boolean} true if the item would render something.
 */
export const isRenderableDescription = (
	description,
	{ isDescription = false, moreParkHoursId } = {}
) => {
	const resolvedLink = isDescription ? description?.link : description;
	return Boolean(
		resolvedLink?.href ||
			description?.image ||
			description?.title ||
			description?.parkHour ||
			description?.displayInlineImage ||
			(moreParkHoursId !== undefined && description?.id === moreParkHoursId)
	);
};
